import { AbstractPostQuoteRequestSchema } from '../quote/post-quote.ts';
import { CustomisedQuotePayloadByProductTypeSchema } from '../quote/quote-payload.ts';
import { PostQuoteResponseSchema } from './post-quote.ts';
import { z } from 'zod';

export const PostCustomRequestQuotesRequestSchema = z.object({
    quotes: z.array(
        AbstractPostQuoteRequestSchema.omit({ callbackUrl: true })
            .extend({ partnerOrganizationId: z.number().int().positive() })
            .and(CustomisedQuotePayloadByProductTypeSchema)
    ),
});

export const PostCustomRequestQuotesResponseSchema = z.array(PostQuoteResponseSchema);

export type PostCustomRequestQuotesRequest = z.infer<typeof PostCustomRequestQuotesRequestSchema>;
export type PostCustomRequestQuotesResponse = z.infer<typeof PostCustomRequestQuotesResponseSchema>;
